module.exports = __webpack_public_path__ + "static/img/information.eeb5a455.png";